module.exports = __webpack_public_path__ + "static/media/mattress-removal.934a8e16.svg";